import React, { FC, lazy } from 'react'
import { Switch } from 'react-router-dom'
import { FrontUrls } from 'Constants/FrontUrls'
import { LazyRoute } from 'Modules'

const ActsListLazy = lazy(() => import('Pages/acts/components/mobile_acts/ActsList'))

const ActsFiltersLazy = lazy(() => import('Pages/acts/components/mobile_acts/Filters'))

const ActsInfoLazy = lazy(() => import('Pages/acts/components/mobile_acts/Info'))

const SignLazy = lazy(() => import('Pages/acts/components/mobile_acts/SignAct'))

const CancelLazy = lazy(() => import('Pages/acts/components/mobile_acts/CancelAct'))

export const ActsMobileRoutes: FC = () => {
	return (
		<Switch>
			<LazyRoute
				exact
				path={FrontUrls.new_acts}
				lazyComponent={ActsListLazy}
				key={FrontUrls.new_acts}
			/>
			<LazyRoute
				exact
				path={FrontUrls.act_mobile.filter}
				lazyComponent={ActsFiltersLazy}
				key={FrontUrls.act_mobile.filter}
			/>
			<LazyRoute
				exact
				path={FrontUrls.act_mobile.info}
				lazyComponent={ActsInfoLazy}
				key={FrontUrls.act_mobile.info}
			/>
			<LazyRoute
				exact
				path={FrontUrls.act_mobile.sign}
				lazyComponent={SignLazy}
				key={FrontUrls.act_mobile.sign}
			/>
			<LazyRoute
				exact
				path={FrontUrls.act_mobile.cancel}
				lazyComponent={CancelLazy}
				key={FrontUrls.act_mobile.cancel}
			/>
		</Switch>
	)
}
